// src/pages/Policy/PolicyPage.jsx
import React, { useState } from "react";
import {
    Container,
    Typography,
    Paper,
    Divider,
    Button,
    Box,
    Link,
} from "@mui/material";

export default function PolicyPage() {
    const [lang, setLang] = useState("pt");

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper sx={{ p: 4 }}>
                {/* Botão de troca de idioma */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setLang(lang === "pt" ? "en" : "pt")}
                    >
                        {lang === "pt" ? "English" : "Português"}
                    </Button>
                </Box>

                {lang === "pt" ? (
                    <>
                        <Typography variant="h4" gutterBottom>
                            Política de Privacidade - BioaiLab App
                        </Typography>

                        <Typography variant="body1" paragraph>
                            O BioaiLab App respeita a sua privacidade e está comprometido
                            em proteger os dados pessoais dos usuários em conformidade
                            com a LGPD (Lei Geral de Proteção de Dados – Brasil), GDPR
                            (General Data Protection Regulation – União Europeia) e
                            demais legislações aplicáveis.
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="h6">1. Uso da Câmera</Typography>
                        <Typography variant="body2" paragraph>
                            O aplicativo solicita a permissão de acesso à câmera
                            exclusivamente para registrar fotos de amostras e gerar
                            evidências durante o processo de coleta em laboratório.
                            Nenhuma imagem é compartilhada com terceiros sem o
                            consentimento explícito do usuário.
                        </Typography>

                        <Typography variant="h6">2. Coleta de Dados</Typography>
                        <Typography variant="body2" paragraph>
                            O BioaiLab App pode coletar os seguintes dados:
                        </Typography>
                        <ul>
                            <li>Fotos capturadas pela câmera (quando autorizado).</li>
                            <li>
                                Dados de localização geográfica, quando o usuário permite,
                                para associar as amostras ao ponto de coleta.
                            </li>
                            <li>
                                Informações técnicas do dispositivo (modelo, sistema
                                operacional, versão do aplicativo).
                            </li>
                            <li>
                                Dados de autenticação e perfil, necessários para o acesso
                                seguro ao sistema.
                            </li>
                        </ul>

                        <Typography variant="h6">3. Base Legal para Tratamento</Typography>
                        <Typography variant="body2" paragraph>
                            O tratamento de dados é realizado com base nas seguintes
                            hipóteses legais previstas pela LGPD e GDPR:
                        </Typography>
                        <ul>
                            <li>Consentimento explícito do usuário.</li>
                            <li>Execução de contrato ou procedimentos preliminares.</li>
                            <li>Atendimento a obrigações legais e regulatórias.</li>
                            <li>Legítimo interesse da empresa para melhoria dos serviços.</li>
                        </ul>

                        <Typography variant="h6">4. Armazenamento e Segurança</Typography>
                        <Typography variant="body2" paragraph>
                            Os dados são armazenados em servidores seguros e protegidos
                            por criptografia. Apenas usuários autenticados e autorizados
                            têm acesso. Adotamos medidas técnicas e administrativas para
                            proteger contra acessos não autorizados, perda ou vazamento
                            de informações.
                        </Typography>

                        <Typography variant="h6">5. Compartilhamento com Terceiros</Typography>
                        <Typography variant="body2" paragraph>
                            O BioaiLab não vende nem compartilha seus dados pessoais com
                            terceiros para fins comerciais. O compartilhamento poderá
                            ocorrer apenas nas seguintes situações:
                        </Typography>
                        <ul>
                            <li>Com parceiros laboratoriais autorizados.</li>
                            <li>
                                Para cumprimento de exigências legais ou ordens judiciais.
                            </li>
                            <li>
                                Com provedores de serviços essenciais (ex.: hospedagem em
                                nuvem), sempre respeitando cláusulas contratuais de
                                confidencialidade.
                            </li>
                        </ul>

                        <Typography variant="h6">6. Retenção de Dados</Typography>
                        <Typography variant="body2" paragraph>
                            Os dados coletados serão mantidos pelo período necessário
                            para cumprimento das finalidades desta política e das
                            obrigações legais. Após esse prazo, poderão ser anonimizados
                            ou excluídos de forma segura.
                        </Typography>

                        <Typography variant="h6">7. Direitos do Usuário</Typography>
                        <Typography variant="body2" paragraph>
                            De acordo com a LGPD e o GDPR, você possui os seguintes
                            direitos:
                        </Typography>
                        <ul>
                            <li>Acessar seus dados pessoais.</li>
                            <li>Corrigir dados incompletos, inexatos ou desatualizados.</li>
                            <li>Solicitar a exclusão de dados pessoais.</li>
                            <li>Revogar o consentimento previamente fornecido.</li>
                            <li>Solicitar a portabilidade de seus dados.</li>
                            <li>
                                Ser informado sobre o compartilhamento de dados com
                                terceiros.
                            </li>
                        </ul>

                        <Typography variant="h6">8. Cookies e Tecnologias Semelhantes</Typography>
                        <Typography variant="body2" paragraph>
                            O BioaiLab App pode utilizar cookies ou identificadores
                            semelhantes em sua versão web para melhorar a experiência do
                            usuário, analisar métricas de uso e garantir segurança. Você
                            pode configurar seu navegador para bloquear cookies, mas isso
                            pode afetar o funcionamento do sistema.
                        </Typography>

                        <Typography variant="h6">9. Menores de Idade</Typography>
                        <Typography variant="body2" paragraph>
                            O BioaiLab App não é destinado a menores de 13 anos. Caso
                            identifiquemos que dados de menores foram coletados sem
                            consentimento dos responsáveis, realizaremos a exclusão
                            imediata.
                        </Typography>

                        <Typography variant="h6">10. Atualizações desta Política</Typography>
                        <Typography variant="body2" paragraph>
                            Esta política poderá ser atualizada periodicamente para
                            refletir alterações legais, técnicas ou operacionais. Sempre
                            que houver mudanças relevantes, notificaremos os usuários
                            pelo aplicativo ou outros meios adequados.
                        </Typography>

                        <Typography variant="h6">11. Contato</Typography>
                        <Typography variant="body2" paragraph>
                            Em caso de dúvidas ou solicitações relacionadas a esta
                            política, entre em contato com nosso Encarregado de Dados
                            (DPO) pelo e-mail:{" "}
                            <Link href="mailto:suporte@bioailab.com">
                                suporte@bioailab.com
                            </Link>
                            .
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="h4" gutterBottom>
                            Privacy Policy - BioaiLab App
                        </Typography>

                        <Typography variant="body1" paragraph>
                            BioaiLab App respects your privacy and is committed to
                            protecting users&apos; personal data in accordance with the
                            LGPD (Brazil), GDPR (European Union), and other applicable
                            data protection laws.
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="h6">1. Camera Usage</Typography>
                        <Typography variant="body2" paragraph>
                            The app requests camera permission exclusively to capture
                            sample photos and generate evidence during the laboratory
                            collection process. No images are shared with third parties
                            without the user&apos;s explicit consent.
                        </Typography>

                        <Typography variant="h6">2. Data Collection</Typography>
                        <Typography variant="body2" paragraph>
                            BioaiLab App may collect the following data:
                        </Typography>
                        <ul>
                            <li>Photos taken via the camera (when authorized).</li>
                            <li>
                                Geolocation data, if enabled, to link samples with the
                                collection site.
                            </li>
                            <li>
                                Device information (model, OS, app version).
                            </li>
                            <li>
                                Authentication and profile data for secure system access.
                            </li>
                        </ul>

                        <Typography variant="h6">3. Legal Basis for Processing</Typography>
                        <Typography variant="body2" paragraph>
                            Data processing is carried out under the following legal
                            grounds (LGPD/GDPR):
                        </Typography>
                        <ul>
                            <li>User&apos;s explicit consent.</li>
                            <li>Performance of a contract or pre-contractual steps.</li>
                            <li>Compliance with legal obligations.</li>
                            <li>
                                Legitimate interests of the company for service improvement.
                            </li>
                        </ul>

                        <Typography variant="h6">4. Storage and Security</Typography>
                        <Typography variant="body2" paragraph>
                            Data is stored on secure, encrypted servers. Only
                            authenticated and authorized users have access. We apply
                            technical and administrative safeguards to prevent
                            unauthorized access, loss, or leakage.
                        </Typography>

                        <Typography variant="h6">5. Sharing with Third Parties</Typography>
                        <Typography variant="body2" paragraph>
                            BioaiLab does not sell or share your personal data for
                            commercial purposes. Sharing may occur only in these cases:
                        </Typography>
                        <ul>
                            <li>With authorized laboratory partners.</li>
                            <li>
                                To comply with legal requirements or court orders.
                            </li>
                            <li>
                                With essential service providers (e.g., cloud hosting)
                                under strict confidentiality agreements.
                            </li>
                        </ul>

                        <Typography variant="h6">6. Data Retention</Typography>
                        <Typography variant="body2" paragraph>
                            Data will be retained for as long as necessary to fulfill the
                            purposes outlined in this policy and legal obligations. After
                            this period, data may be anonymized or securely deleted.
                        </Typography>

                        <Typography variant="h6">7. User Rights</Typography>
                        <Typography variant="body2" paragraph>
                            Under LGPD and GDPR, you have the following rights:
                        </Typography>
                        <ul>
                            <li>Access your personal data.</li>
                            <li>Correct incomplete, inaccurate, or outdated data.</li>
                            <li>Request deletion of your personal data.</li>
                            <li>Withdraw previously given consent.</li>
                            <li>Request data portability.</li>
                            <li>
                                Be informed about data sharing with third parties.
                            </li>
                        </ul>

                        <Typography variant="h6">8. Cookies and Similar Technologies</Typography>
                        <Typography variant="body2" paragraph>
                            BioaiLab App may use cookies or similar identifiers in its web
                            version to enhance user experience, analyze usage metrics, and
                            ensure security. You can configure your browser to block
                            cookies, but this may affect functionality.
                        </Typography>

                        <Typography variant="h6">9. Children&apos;s Privacy</Typography>
                        <Typography variant="body2" paragraph>
                            BioaiLab App is not directed to children under 13 years old.
                            If we identify that children&apos;s data has been collected
                            without parental consent, we will delete it immediately.
                        </Typography>

                        <Typography variant="h6">10. Updates to this Policy</Typography>
                        <Typography variant="body2" paragraph>
                            This policy may be updated periodically to reflect legal,
                            technical, or operational changes. Whenever relevant changes
                            occur, we will notify users through the app or other
                            appropriate channels.
                        </Typography>

                        <Typography variant="h6">11. Contact</Typography>
                        <Typography variant="body2" paragraph>
                            For questions or requests regarding this policy, please
                            contact our Data Protection Officer (DPO) at:{" "}
                            <Link href="mailto:suporte@bioailab.com">
                                suporte@bioailab.com
                            </Link>
                            .
                        </Typography>
                    </>
                )}
            </Paper>
        </Container>
    );
}
